// Hladanie v uz nacitanych zoznamoch (majitelia, najomcovia, pobocky,
// pouzivatelia). Velke zoznamy (vozidla, zakazky, uskladnenky) hlada server.
//
// Pravidla, aby to fungovalo tak, ako ludia pisu:
//  - nezalezi na velkosti pismen ani na diakritike (Piestany najde Piešťany),
//  - viac slov znamena "musi sedie vsetko" (Kaufland Bratislava),
//  - hlada sa naraz vo vsetkych poliach, ktore sekcia posle.

export const bezDiakritiky = (text) =>
  String(text === null || text === undefined ? "" : text)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

/**
 * @param {Array} zoznam data, v ktorych sa hlada
 * @param {string} text co pouzivatel napisal
 * @param {Function} vyberPolia dostane polozku, vrati pole hodnot na prehladanie
 */
export const filtrujZoznam = (zoznam, text, vyberPolia) => {
  const data = Array.isArray(zoznam) ? zoznam : [];
  const hladane = bezDiakritiky(text).trim();
  if (hladane === "") {
    return data;
  }
  const slova = hladane.split(/\s+/);
  return data.filter((polozka) => {
    let polia = [];
    try {
      polia = vyberPolia(polozka) || [];
    } catch (e) {
      polia = [];
    }
    const seno = bezDiakritiky(polia.join(" "));
    return slova.every((slovo) => seno.indexOf(slovo) !== -1);
  });
};
